import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private menuOpen = new BehaviorSubject<boolean>(true);
  menuOpen$ = this.menuOpen.asObservable();

  toggleMenu() {
    this.menuOpen.next(!this.menuOpen.value);
  }
}
